// JavaScript Document
// Version: 1.0.0

jQuery(document).ready(function($) {

});



/**
 * Recupera il token di sicurezza.
 *
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function getCsrfToken(successCallback, errorCallback) {
	jQuery.ajax({
		url: minerva_drupal_vars.host + minerva_drupal_vars.endpoints.token,
		method: "GET",
		success: function (response) {
			console.log('getCsrfToken');
			console.log('OK');

			var token = response;

			createCookie('token', token, 'session');
			successCallback(token);
		},
		error: function(error) {
			if ( 0 == error.status && null == error.responseJSON ) {
				error = {
					status: 503,
					statusText: 'Service Unavailable [token]',
				};
			}

			errorCallback(error);
		}
	});
}



/**
 * Verifica se l'utente è loggato.
 *
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function checkConnect(successCallback, errorCallback) {
	getCsrfToken(
		function(token) {
			//displayLoading(true, 'connect');

			jQuery.ajax({
				url: minerva_drupal_vars.host + minerva_drupal_vars.endpoints.connect,
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": token
				},
				xhrFields: {
					withCredentials: true
				},
				success: function (response) {
					console.log('checkConnect');

					if ( response == 0 ) {
						var loggedIn = false;

						console.log('not logged-in');

						Cookies.remove('instance');
						successCallback(loggedIn, token);
					} else if ( response == 1 ) {
						// La funzione del controller Drupal, modificata per l'occorrenza, è stata sovrascritta durante un aggiornamento.
						// Considero l'utente loggato, ma mostro un messaggio di errore perché:
						//   - non sarà possibile effettuare il logout dell'utente
						//   - un successivo tentativo di loggarsi genererebbe un errore (la route è accessibile solo per gli utenti anonimi)

						var loggedIn = true;

						console.log('1');

						//successCallback(loggedIn, token);
						errorCallback(minerva_drupal_vars.wrong_response);
					} else {
						// "response" è un JSON così strutturato:
						//    {
						//       "current_user": {
						//          "uid": "",
						//          "name": ""
						//       },
						//       "csrf_token": "",
						//       "logout_token": ""
						//    }

						var loggedIn            = true;
						var cookieValue         = {};

						cookieValue.userId      = parseInt(response.current_user.uid);
						cookieValue.userName    = response.current_user.name;
						cookieValue.token       = response.csrf_token;
						cookieValue.logoutToken = response.logout_token;

						console.log('logged-in');

						createCookie('instance', JSON.stringify(cookieValue), 'session');
						successCallback(loggedIn, response.csrf_token);
					}
				},
				error: function(error) {
					if ( 0 == error.status && null == error.responseJSON ) {
						error = {
							status: 503,
							statusText: 'Service Unavailable [connect]',
						};
					}

					errorCallback(error);
				}
			});
		},
		function(error) {
			errorCallback(error);
		});
}



/**
 * Effettua il login dell'utente.
 *
 * @param {object}   loginData       : JSON con le credenziali di accesso
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function login(loginData, successCallback, errorCallback) {
	checkConnect(
		function(loggedIn, token) {
			if (loggedIn) {
				successCallback();
			} else {
				Cookies.remove('instance');

				jQuery.ajax({
					url: minerva_drupal_vars.host + minerva_drupal_vars.endpoints.login,
					method: "POST",
					data: JSON.stringify(loginData),
					headers: {
						"Content-Type": "application/json",
						"X-CSRF-Token": token
					},
					xhrFields: {
						withCredentials: true
					},
					success: function (response) {
						console.log('login');
						console.log('OK');

						// "response" è un JSON così strutturato:
						//    {
						//       "current_user": {
						//          "uid": "",
						//          "name": ""
						//       },
						//       "csrf_token": "",
						//       "logout_token": ""
						//    }

						var cookieValue         = {};

						cookieValue.userId      = parseInt(response.current_user.uid);
						cookieValue.userName    = response.current_user.name;
						cookieValue.token       = response.csrf_token;
						cookieValue.logoutToken = response.logout_token;
						cookieValue.basicAuth   = formatBasicAuth(loginData);

						createCookie('instance', JSON.stringify(cookieValue), 'session');
						successCallback(response.current_user.uid);
					},
					error: function(error) {
						if ( 0 == error.status && null == error.responseJSON ) {
							error = {
								status: 503,
								statusText: 'Service Unavailable [login]',
							};
						}

						errorCallback(error);
					}
				});
			}
		},
		function(error) {
			errorCallback(error);
		});
}



/**
 * Effettua il logout dell'utente.
 *
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function logout(successCallback, errorCallback) {
	checkConnect(
		function(loggedIn, token) {
			if (loggedIn) {
				if ( is_defined(Cookies.get('instance')) ) {
					var cookieValue = JSON.parse(Cookies.get('instance'));

					jQuery.ajax({
						url: minerva_drupal_vars.host + minerva_drupal_vars.endpoints.logout + '&token=' + cookieValue.logoutToken,
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"X-CSRF-Token": token
						},
						xhrFields: {
							withCredentials: true
						},
						success: function() {
							console.log('logout');
							console.log('OK');

							Cookies.remove('instance');
							successCallback();
						},
						error: function(error) {
							if ( 0 == error.status && null == error.responseJSON ) {
								error = {
									status: 503,
									statusText: 'Service Unavailable [logout]',
								};
							}

							errorCallback(error);
						}
					});
				} else {
					// Senza il logoutToken, presente nel cookie "instance" e fornito da Drupal, non è possibile effettuare il logout dell'utente.
					errorCallback({
						status: 'none',
						responseText: minerva_drupal_vars.wrong_logout
					});
				}
			} else {
				console.log('logout');
				console.log('not logged-in');

				Cookies.remove('instance');
				successCallback();
			}
		},
		function(error) {
			errorCallback(error);
		});
}



/**
 * Recupera le informazioni di un utente.
 *
 * @param {int}      userId          :
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function userInfo(userId, successCallback, errorCallback) {
	getCsrfToken(
		function(token) {
			jQuery.ajax({
				url: minerva_drupal_vars.host + minerva_drupal_vars.endpoints.user_info.replace('{uid}', userId),
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": token
				},
				xhrFields: {
					withCredentials: true
				},
				success: function(response) {
					console.log('userInfo');
					console.log('OK');

					successCallback(response);
				},
				error: function(error) {
					if ( 0 == error.status && null == error.responseJSON ) {
						error = {
							status: 503,
							statusText: 'Service Unavailable [user_info]',
						};
					}

					errorCallback(error);
				}
			});
		},
		function(error) {
			errorCallback(error);
		});
}



/**
 * Recupera l'ID dell'utente connesso.
 *
 * @param {int}      userId          :
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function userId(successCallback, errorCallback) {
	getCsrfToken(
		function(token) {
			jQuery.ajax({
				url: minerva_drupal_vars.host + minerva_drupal_vars.endpoints.user_id,
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": token
				},
				xhrFields: {
					withCredentials: true
				},
				success: function(response) {
					var result = response.match(/user\/[0-9]*/)[0];
					var userId = parseInt(result.split('/')[1]);

					console.log('userId');
					console.log('OK');

					successCallback(userId);
				},
				error: function(error) {
					if ( 0 == error.status && null == error.responseJSON ) {
						error = {
							status: 503,
							statusText: 'Service Unavailable [user_id]',
						};
					}

					errorCallback(error);
				}
			})/*.done(function (data, textStatus, xhr) {
				// <https://www.prodir.com/en/user/24>; rel="canonical", <https://www.prodir.com/en/user/24>; rel="alternate"; hreflang="en"
				var link = xhr.getResponseHeader('Link');

				console.log(link);
			})*/;
		},
		function(error) {
			errorCallback(error);
		});
}



/**
 * Effettua il login dell'utente.
 *
 * @param {object}   requestData     :
 * @param {string}   token
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function createNode(requestData, token, successCallback, errorCallback) {
	jQuery.ajax({
		url: minerva_drupal_vars.host + minerva_drupal_vars.endpoints.save,
		method: "POST",
		data: JSON.stringify(requestData),
		headers: {
			"Content-Type": "application/json",
			"X-CSRF-Token": token
		},
		xhrFields: {
			withCredentials: true
		},
		success: function (response) {
			// "response" è un JSON che rappresenta il nodo Drupal appena creato:
			//    {
			//       "nid": [{ "value": 35 }],
			//       "uuid": [{ "value": "7598e38d-ef95-424e-8e93-fb17497bb139" }],
			//       "vid": [{ "value": 94 }],
			//       "langcode": [{ "value": "en" }],
			//       "type": [{ "target_id": "pen_configuration", "target_type": "node_type", "target_uuid": "ad2edc0f-ecaf-4e0c-a4a0-83c49f35e6c5" }],
			//       "revision_timestamp": [{ "value": "2019-01-05T16:17:27+00:00", "format": "Y-m-d\\TH:i:sP" }],
			//       "revision_uid": [{ "target_id": 24, "target_type": "user", "target_uuid": "2e8167f4-bfea-412b-8079-ed47dd5e4814", "url": "/en/user/24" }],
			//       "revision_log": [],
			//       "status": [{ "value": true }],
			//       "title": [{ "value": "empty test" }],
			//       "uid": [{ "target_id": 24, "target_type": "user", "target_uuid": "2e8167f4-bfea-412b-8079-ed47dd5e4814", "url": "/en/user/24" }],
			//       "created": [ "value": "2019-01-05T16:17:27+00:00", "format": "Y-m-d\\TH:i:sP }],
			//       "changed": [{ value": "2019-01-05T16:17:27+00:00", "format": "Y-m-d\\TH:i:sP" }],
			//       "promote": [{ "value": false }],
			//       "sticky": [{ "value": false }],
			//       "default_langcode": [{ "value": true }],
			//       "revision_translation_affected": [{ "value": true }],
			//       "content_translation_source": [{ "value": "und" }],
			//       "content_translation_outdated": [{ "value": false }],
			//       "field_date_creation": [{ "value": "2019-01-05T16:17:29" }],
			//       "field_jsonconfiguration": [],
			//       "field_jsonextendedconfiguration": [],
			//       "field_model": [],
			//       "field_penid": [{ "value": "0" }],
			//       "field_pen_image_conf": [],
			//       "field_pen_image_conf_text": [],
			//       "field_pen_image_conf_text_txt": [],
			//       "field_pen_image_conf_txt": [],
			//       "field_pen_text": []
			//    }
			console.log('createNode');
			console.log('OK');

			successCallback(response);
		},
		error: function(error) {
			if ( 0 == error.status && null == error.responseJSON ) {
				error = {
					status: 503,
					statusText: 'Service Unavailable [save]',
				};
			}

			errorCallback(error);
		}
	});
}
